import React, { memo } from "react";
import {
  IconPhone,
  IconMail,
  IconMapPin,
  IconUser,
  IconCalendar,
  IconTag,
} from "@tabler/icons-react";
import { ServiceStatusBadge } from "../common";
import { formatPhone, formatDate } from "../../utils/formatters";
import "./ContactInfo.css";

/**
 * Informações do contato
 */
const ContactInfo = memo(({ contact, conversation }) => {
  const contactName = contact?.name || conversation?.name || "Sem nome";
  const contactPhone = contact?.phone || conversation?.phone;
  const avatarUrl = contact?.profile_picture ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(contactName)}&background=random&size=120`;

  return (
    <div className="sc-contact-info">
      {/* Avatar e nome */}
      <div className="sc-contact-info__header">
        <img
          src={avatarUrl}
          alt={contactName}
          className="sc-contact-info__avatar"
        />
        <h3 className="sc-contact-info__name">{contactName}</h3>
        {conversation?.service_status && (
          <ServiceStatusBadge status={conversation.service_status} />
        )}
      </div>

      {/* Dados do contato */}
      <div className="sc-contact-info__details">
        <div className="sc-contact-info__item">
          <IconPhone size={18} className="sc-contact-info__icon" />
          <div className="sc-contact-info__content">
            <span className="sc-contact-info__label">Telefone</span>
            <span className="sc-contact-info__value">
              {formatPhone(contactPhone)}
            </span>
          </div>
        </div>

        {contact?.email && (
          <div className="sc-contact-info__item">
            <IconMail size={18} className="sc-contact-info__icon" />
            <div className="sc-contact-info__content">
              <span className="sc-contact-info__label">E-mail</span>
              <span className="sc-contact-info__value">{contact.email}</span>
            </div>
          </div>
        )}

        {contact?.address && (
          <div className="sc-contact-info__item">
            <IconMapPin size={18} className="sc-contact-info__icon" />
            <div className="sc-contact-info__content">
              <span className="sc-contact-info__label">Endereço</span>
              <span className="sc-contact-info__value">{contact.address}</span>
            </div>
          </div>
        )}

        {conversation?.current_attendant && (
          <div className="sc-contact-info__item">
            <IconUser size={18} className="sc-contact-info__icon" />
            <div className="sc-contact-info__content">
              <span className="sc-contact-info__label">Atendente atual</span>
              <span className="sc-contact-info__value">
                {conversation.current_attendant.name || conversation.current_attendant.username}
              </span>
            </div>
          </div>
        )}

        {conversation?.department && (
          <div className="sc-contact-info__item">
            <IconTag size={18} className="sc-contact-info__icon" />
            <div className="sc-contact-info__content">
              <span className="sc-contact-info__label">Departamento</span>
              <span className="sc-contact-info__value">
                {conversation.department.name}
              </span>
            </div>
          </div>
        )}

        {contact?.created_at && (
          <div className="sc-contact-info__item">
            <IconCalendar size={18} className="sc-contact-info__icon" />
            <div className="sc-contact-info__content">
              <span className="sc-contact-info__label">Cliente desde</span>
              <span className="sc-contact-info__value">
                {formatDate(contact.created_at)}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Tags */}
      {contact?.tags && contact.tags.length > 0 && (
        <div className="sc-contact-info__tags">
          <span className="sc-contact-info__tags-label">Tags</span>
          <div className="sc-contact-info__tags-list">
            {contact.tags.map((tag, index) => (
              <span
                key={index}
                className="sc-contact-info__tag"
                style={{ backgroundColor: tag.color || "#f1f5f9" }}
              >
                {tag.name || tag}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

ContactInfo.displayName = "ContactInfo";

export default ContactInfo;
